import { jlptOverseasSites } from "./jlptOverseasSites";

// Bridges a canonical ISO 3166-1 alpha-2 country code to the exact,
// non-canonical country string used in the JLPT overseas directory data
// (jlptOverseasSites.generated.json), e.g. "PT" -> "PORTUGAL",
// "GB" -> "U.K.". Only codes that actually appear in the directory are
// listed - a code with no entry here simply has no known directory country
// name, which countryCodeHasJlptLocations treats as "no locations".
export const JLPT_DIRECTORY_COUNTRY_NAMES: Record<string, string> = {
    AR: "---> ARGENTINA",
    DZ: "ALGERIA",
    AM: "ARMENIA",
    AU: "AUSTRALIA",
    AT: "AUSTRIA",
    AZ: "AZERBAIJAN",
    BD: "BANGLADESH",
    BY: "BELARUS",
    BE: "BELGIUM",
    BJ: "BENIN",
    BT: "BHUTAN",
    BO: "BOLIVIA",
    BA: "BOSNIA AND HERZEGOVINA",
    BR: "BRAZIL",
    BN: "BRUNEI",
    BG: "BULGARIA",
    KH: "CAMBODIA",
    CA: "CANADA",
    CL: "CHILE",
    CN: "CHINA",
    CO: "COLOMBIA",
    CR: "COSTA RICA",
    CI: "COTE D'IVOIRE",
    CZ: "CZECH REPUBLIC",
    DK: "DENMARK",
    DO: "DOMINICAN REPUBLIC",
    CD: "DR CONGO",
    EC: "ECUADOR",
    EG: "EGYPT",
    SV: "EL SALVADOR",
    FJ: "FIJI",
    FI: "FINLAND",
    FR: "FRANCE",
    GE: "GEORGIA",
    DE: "GERMANY",
    GH: "GHANA",
    GR: "GREECE",
    HU: "HUNGARY",
    IN: "INDIA",
    ID: "INDONESIA",
    IR: "IRAN",
    IE: "IRELAND",
    IL: "ISRAEL",
    IT: "ITALY",
    JO: "JORDAN",
    KZ: "KAZAKHSTAN",
    KE: "KENYA",
    KR: "KOREA",
    KG: "KYRGYZ REPUBLIC",
    LA: "LAOS",
    LT: "LITHUANIA",
    MG: "MADAGASCAR",
    MY: "MALAYSIA",
    MV: "MALDIVES",
    MX: "MEXICO",
    MD: "MOLDOVA",
    MN: "MONGOLIA",
    MA: "MOROCCO",
    MM: "MYANMAR",
    NP: "NEPAL",
    NZ: "NEW ZEALAND",
    NO: "NORWAY",
    PK: "PAKISTAN",
    PA: "PANAMA",
    PG: "PAPUA NEW GUINEA",
    PY: "PARAGUAY",
    PE: "PERU",
    PH: "PHILIPPINES",
    PL: "POLAND",
    PT: "PORTUGAL",
    QA: "QATAR",
    RO: "ROMANIA",
    RU: "RUSSIA",
    SA: "SAUDI ARABIA",
    SN: "SENEGAL",
    RS: "SERBIA",
    SG: "SINGAPORE",
    SI: "SLOVENIA",
    ZA: "SOUTH AFRICA",
    ES: "SPAIN",
    LK: "SRI LANKA",
    SE: "SWEDEN",
    CH: "SWITZERLAND",
    TW: "TAIWAN",
    TJ: "TAJIKISTAN",
    TH: "THAILAND",
    NL: "THE NETHERLANDS",
    TT: "TRINIDAD AND TOBAGO",
    TN: "TUNISIA",
    TR: "TURKEY",
    TM: "TURKMENISTAN",
    TL: "Timor Leste",
    GB: "U.K.",
    US: "U.S.A.",
    UA: "UKRAINE",
    UY: "URUGUAY",
    UZ: "UZBEKISTAN",
    AE: "United Arab Emirates",
    VE: "VENEZUELA",
    VN: "VIETNAM",
};

// A site only counts as a real, bookable JLPT location if it isn't
// suspended/pending and actually has a host institution announced -
// Portugal, for example, is present in the directory only as a suspended
// placeholder record with no host, and must not count as "has locations".
export function countryCodeHasJlptLocations(code: string | null): boolean {
    if (!code) return false;
    const directoryName = JLPT_DIRECTORY_COUNTRY_NAMES[code];
    if (!directoryName) return false;
    return jlptOverseasSites.some(
        (site) => site.country === directoryName && !site.suspensionStatus && Boolean(site.hostInstitution)
    );
}
